<div class="share-comps-table-container">
  <div class="input-container">
    <div class="search-container">
      <nz-input-group
        [nzSize]="'small'"
        id="search-input"
        [nzPrefix]="prefixTemplateUser"
      >
        <input
          #searchInput
          type="text"
          [formControl]="userInput"
          class="share-search-input"
          nz-input
          [nzAutocomplete]="auto"
          spellcheck="false"
          placeholder="Search name or email"
        />
        <nz-autocomplete
          nzBackfill
          [nzOverlayClassName]="'suggestion-dropdown'"
          #auto
        >
          <nz-auto-option
            *ngFor="let suggestion of suggestedUserList"
            (click)="onSuggestionSelected()"
            [nzValue]="suggestion.email"
          >
            {{ suggestion.full_name }} ({{ suggestion.email }})
          </nz-auto-option>
          <nz-auto-option
            *ngIf="
              suggestedUserList.length === 0 &&
              userInput.value !== null &&
              userInput.value.length > 2 &&
              allowUserSuggestionError
            "
            class="not-found"
          >
            <va-icon name="faExclamationCircle" isFontAwesome="true"></va-icon>
            No name or email matches the input
          </nz-auto-option>
        </nz-autocomplete>
      </nz-input-group>
      <ng-template #prefixTemplateUser
        ><va-icon
          name="search"
          class="fal fa-md"
          style="color: #979797"
        ></va-icon
      ></ng-template>
    </div>
    <div class="btn-container">
      <button
        nz-button
        nzType="primary"
        [disabled]="disableShareBtn"
        (click)="shareComps(searchInput)"
      >
        Share
      </button>
    </div>
  </div>
  <div
    class="share-grid-container"
    [ngClass]="{ emptytbl: listOfTableData.length < 1 }"
  >
    <nz-table
      [nzData]="listOfTableData"
      [nzFrontPagination]="false"
      [nzShowPagination]="false"
      [nzScroll]="{ y: '300px' }"
    >
      <thead (nzSortChange)="onSortChange($event)" nzSingleSort>
        <tr>
          <th
            [nzShowSort]="true"
            nzWidth="140px"
            [nzAlign]="'left'"
            nzSortKey="company"
          >
            Company
          </th>
          <th
            [nzShowSort]="true"
            nzWidth="140px"
            [nzAlign]="'left'"
            nzSortKey="recipient"
          >
            Recipient
          </th>
          <th
            [nzShowSort]="true"
            nzWidth="auto"
            [nzAlign]="'left'"
            nzSortKey="email"
          >
            Email
          </th>
          <th
            [nzShowSort]="true"
            nzWidth="110px"
            [nzAlign]="'left'"
            nzSortKey="status"
          >
            Status
          </th>
          <th
            [nzShowSort]="true"
            nzWidth="150px"
            [nzAlign]="'left'"
            nzSortKey="time"
          >
            Date Sent
          </th>
        </tr>
      </thead>
      <tbody *ngIf="listOfTableData.length > 0; else emptyListBlock">
        <tr *ngFor="let data of listOfTableData">
          <td [title]="data.company">{{ data.company | textEllipsis: 14 }}</td>
          <td [title]="data.recipient">
            {{ data.recipient | textEllipsis: 14 }}
          </td>
          <td [title]="data.email">{{ data.email | textEllipsis: 30 }}</td>
          <td [style.color]="statusColor[data.status.toLowerCase()]">
            {{ data.status }}
          </td>
          <td>{{ data.time }}</td>
        </tr>
      </tbody>
    </nz-table>
    <ng-template #emptyListBlock>
      <div class="empty-content" *ngIf="componentType === 'peer-analysis'">
        <p>
          You haven't shared this Peer Analysis Table to anyone, Please search
          and share.
        </p>
      </div>
      <div
        class="empty-content"
        *ngIf="componentType === 'comparative-analysis'"
      >
        <p>
          You haven't shared this Comparative Analysis with anyone. Please
          search name or email to share.
        </p>
      </div>
    </ng-template>
  </div>
</div>
